import styled from "styled-components";

export const BackgroundContainer = styled.div`
  width: 46.875vw;
  height: 1080px;
  background-color: #0f9246;
  /* background-color: #ffff; */
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: flex-start;
  align-items: space-around;
  flex-direction: column;
  @media only screen and (max-height: 1024px) {
    height: 1024px;
  }
  @media only screen and (max-height: 915px) {
    height: 915px;
  }
  @media only screen and (max-height: 900px) {
    height: 900px;
  }
  @media only screen and (max-height: 896px) {
    height: 896px;
  }
  @media only screen and (max-height: 892px) {
    height: 892px;
  }
  @media only screen and (max-height: 873px) {
    height: 873px;
  }
  @media only screen and (max-height: 864px) {
    height: 864px;
  }
  @media only screen and (max-height: 800px) {
    height: 800px;
  }
  @media only screen and (max-height: 768px) {
    height: 768px;
  }
  @media only screen and (max-height: 720px) {
    height: 720px;
  }
  @media only screen and (max-height: 640px) {
    height: 640px;
  }
`;
